export default __webpack_public_path__ + "static/media/google.6dd9c336.svg";